export const ELO_INITAL_RATING = 1500;
export const ELO_K_FACTOR = 40;